import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import SelectorCiudad from "../custom/SelectorCiudad";
import Unauthorized from "../general/Unauthorized";
import { TIPO_USUARIO_LABEL, CUPOS_SALUD, CUPOS_ADMIN } from "../../../resources/tipoUsuarioLabels";

function NuevoUsuario() {

    const [errorlist, setErrorlist] = useState({});
    const [banner, setBanner] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonDatosBasicos, setAcordeonDatosBasicos] = useState(true);
    const [acordeonProfesionalSalud, setAcordeonProfesionalSalud] = useState(false);
    const [acordeonUsuarioSistema, setAcordeonUsuarioSistema] = useState(false);
    //const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    //const [permissions, setPermissions] = useState([]);

    //const [roleName, setRoleName] = useState('');
    //const [roleDescription, setRoleDescription] = useState();

    const [cargos, setCargos] = useState([]);
    const [tiposContrato, setTiposContrato] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);

    const [roles, setRoles] = useState([]);
    const [name, setName] = useState();
    const [lastname, setLastname] = useState();
    const [email, setEmail] = useState();
    const [documento, setDocumento] = useState();
    const [tipoDocumento, setTipoDocumento] = useState();
    const [celular, setCelular] = useState();
    const [cargo, setCargo] = useState();
    const [tipoContrato, setTipoContrato] = useState();
    const [registroMedico, setRegistroMedico] = useState();
    const [especialidad, setEspecialidad] = useState();
    const [codigoHabilitacion, setCodigoHabilitacion] = useState();
    const [direccion, setDireccion] = useState();
    const [ciudadResidencia, setCiudadResidencia] = useState(null);
    const [telefono, setTelefono] = useState();
    const [fechaNacimiento, setFechaNacimiento] = useState();
    const [estadoCivil, setEstadoCivil] = useState();
    const [fechaIngreso, setFechaIngreso] = useState();
    const [porcentajeContratado, setPorcentajeContratado] = useState();




    const [crearCuenta, setCrearCuenta] = useState(false);
    const [asignarRolesVisible, setAsignarRolesVisible] = useState('hide');
    const [camposUsuarioVisible, setCamposUsuarioVisible] = useState(false);
    const [usuariosDisponibles, setUsuariosDisponibles] = useState(0);
    const [usuariosCreados, setUsuariosCreados] = useState(0);
    const [cuposMedicos, setCuposMedicos] = useState({ disponibles: 0, creados: 0 });
    const [cuposAdmin, setCuposAdmin] = useState({ disponibles: 0, creados: 0 });

    const [usrRoles, setUsrRoles] = useState([]);
    const [crearAgenda, setCrearAgenda] = useState(false);
    const [tipoUsuario, setTipoUsuario] = useState('0');
    const [password, setPassword] = useState('');
    const [facturador, setFacturador] = useState(1); // 🆕 Campo facturador - Default 1 (No es facturador)

    /** Solo médico (0) con cuenta: diligenciar_historias = 1; administrativo siempre 0 */
    const resolverDiligenciarHistorias = () => {
        if (!crearCuenta) {
            return 0;
        }
        return parseInt(tipoUsuario, 10) === 0 ? 1 : 0;
    };

    let history = useHistory();

    const clearBanner = () => setBanner({ type: '', message: '' });

    const normalizeApiErrors = (err) => {
        const out = {};
        const data = err.response?.data;
        if (!data) {
            return { general: 'Error de red o del servidor. Intente de nuevo.' };
        }
        if (data.errors) {
            Object.keys(data.errors).forEach((key) => {
                const v = data.errors[key];
                out[key] = Array.isArray(v) ? v[0] : String(v);
            });
            return out;
        }
        if (data.message) {
            return { general: data.message };
        }
        if (typeof data.error === 'string') {
            return { general: data.error };
        }
        return { general: 'Error al crear el usuario.' };
    };

    const scrollToFirstError = (errKeys) => {
        const order = ['name', 'lastname', 'tipo_documento', 'numero_documento', 'documento', 'email', 'celular', 'tipo_contrato', 'tipo_usuario', 'password', 'porcentaje_contratado'];
        const first = order.find((k) => errKeys.includes(k)) || errKeys[0];
        if (!first) return;
        const idMap = { numero_documento: 'documento', tipo_contrato: 'tipo_contrato' };
        const domId = idMap[first] || first;
        document.getElementById(domId)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    let userdata = [];
    //let clientData = [];
    //let userRoles = [];

    const addRole = (roleId) => {
        const userRoles = [...usrRoles];
        const roleIndex = userRoles.indexOf(roleId);
        if (roleIndex > -1) {
            userRoles.splice(roleIndex, 1);
        } else {
            userRoles.push(roleId);
        }

        const roleElement = document.getElementById('role-' + roleId);
        roleElement?.classList.toggle('on');

        setUsrRoles(userRoles);
    };

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
            console.log('DEBUG NuevoUsuario - Usando sistema nuevo de permisos');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
            console.log('DEBUG NuevoUsuario - Usando sistema antiguo de permisos (fallback)');
        }

        console.log('DEBUG NuevoUsuario - tienePermiso gestionPersonal:', tienePermiso); // ✅ DEBUG

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }


        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente');
            });


        axios.get('/roles', config)
            .then(response => {
                if (response.status === 200) {
                    setRoles(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando roles');
            });

        axios.get('/cargos', config)
            .then(response => {
                if (response.status === 200) {
                    setCargos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando cargos');
            });


        axios.get('/tipos-contrato', config)
            .then(response => {
                if (response.status === 200) {
                    setTiposContrato(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando tipos contrato');
            });

        axios.get('/especialidades', config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando especialidades');
            })

        // 📊 CARGAR INFORMACIÓN DE USUARIOS DISPONIBLES
        axios.get('/parametros-cliente', config)
            .then(response => {
                if (response.status === 200 && response.data) {
                    setUsuariosDisponibles(response.data.numero_usuarios_disponibles || 0);
                    setUsuariosCreados(response.data.usuarios_creados || 0);
                    setCuposMedicos({
                        disponibles: response.data.usuarios_medicos_disponibles || 0,
                        creados: response.data.usuarios_medicos_creados || 0,
                    });
                    setCuposAdmin({
                        disponibles: response.data.usuarios_administrativos_disponibles || 0,
                        creados: response.data.usuarios_administrativos_creados || 0,
                    });
                }
            })
            .catch(error => {
                console.log('Error cargando parámetros cliente');
                // Valores por defecto si no se puede cargar
                setUsuariosDisponibles(0);
                setUsuariosCreados(0);
            })
    }, []);


    const cuposLibresMedicos = Math.max(0, cuposMedicos.disponibles - cuposMedicos.creados);
    const cuposLibresAdmin = Math.max(0, cuposAdmin.disponibles - cuposAdmin.creados);
    const hayCuposDisponibles = cuposLibresMedicos > 0 || cuposLibresAdmin > 0;
    const cuposLibresTipo = tipoUsuario === '1' ? cuposLibresAdmin : cuposLibresMedicos;

    const handleCrearCuenta = () => {
        const el = document.getElementById('crear_cuenta');
        if (crearCuenta) {
            clearBanner();
            setCrearCuenta(false);
            setAsignarRolesVisible('hide');
            setCamposUsuarioVisible(false);
            setCrearAgenda(false);
            document.getElementById('agenda-crear')?.classList.remove('on');
            el?.classList.remove('on');
        } else {
            if (!hayCuposDisponibles) {
                setBanner({
                    type: 'danger',
                    message: 'No hay cupos disponibles para activar usuarios del sistema. Contacte al administrador.'
                });
                return;
            }

            clearBanner();
            setCrearCuenta(true);
            setAsignarRolesVisible('');
            setCamposUsuarioVisible(true);
            el?.classList.add('on');
        }
    };

    const handleCrearAgenda = () => {
        if (!crearCuenta) {
            setBanner({
                type: 'warning',
                message: 'Para crear agenda con permisos, primero active «Crear cuenta de usuario en la plataforma».'
            });
            return;
        }
        setCrearAgenda(!crearAgenda);
        document.getElementById('agenda-crear')?.classList.toggle('on');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        clearBanner();
        setErrorlist({});

        const errores = {};
        const docDigits = (documento || '').trim();
        const celDigits = (celular || '').replace(/\D/g, '');

        if (!name || name.trim() === '') {
            errores.name = 'El nombre es requerido';
        } else if (!/^[a-zA-Z\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1\s]+$/.test(name.trim())) {
            errores.name = 'Solo letras y espacios (sin números ni símbolos)';
        }

        if (!lastname || lastname.trim() === '') {
            errores.lastname = 'El apellido es requerido';
        } else if (!/^[a-zA-Z\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1\s]+$/.test(lastname.trim())) {
            errores.lastname = 'Solo letras y espacios (sin números ni símbolos)';
        }

        if (!email || email.trim() === '') {
            errores.email = 'El email es requerido';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
            errores.email = 'El email no tiene un formato válido';
        }

        if (!docDigits) {
            errores.numero_documento = 'El número de documento es requerido';
        } else if (!/^[0-9]+$/.test(docDigits)) {
            errores.numero_documento = 'El documento solo debe contener dígitos';
        } else if (docDigits.length > 20) {
            errores.numero_documento = 'Máximo 20 dígitos';
        }

        if (!tipoDocumento || tipoDocumento.trim() === '') {
            errores.tipo_documento = 'El tipo de documento es requerido';
        }

        if (!celDigits) {
            errores.celular = 'El teléfono celular es requerido';
        } else if (celDigits.length < 10 || celDigits.length > 15) {
            errores.celular = 'El celular debe tener entre 10 y 15 dígitos';
        }

        if (porcentajeContratado && porcentajeContratado !== '') {
            const porcentaje = parseInt(porcentajeContratado, 10);
            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                errores.porcentaje_contratado = 'El porcentaje debe ser un número entre 0 y 100';
            }
        }

        if (!tipoContrato || tipoContrato === '' || tipoContrato === '00') {
            errores.tipo_contrato = 'El tipo de contrato es obligatorio';
        }

        if (crearCuenta) {
            if (tipoUsuario !== '0' && tipoUsuario !== '1') {
                errores.tipo_usuario = 'Seleccione el tipo de usuario';
            } else if (cuposLibresTipo <= 0) {
                errores.tipo_usuario = tipoUsuario === '1'
                    ? 'No hay cupos disponibles para usuarios administrativos'
                    : 'No hay cupos disponibles para usuarios médicos';
            }

            const pwd = String(password || '').trim();
            if (!pwd) {
                errores.password = 'La contraseña es obligatoria para activar el acceso al sistema';
            } else if (pwd.length < 6) {
                errores.password = 'La contraseña debe tener al menos 6 caracteres';
            }
        }

        if (crearAgenda && !crearCuenta) {
            errores.crear_agenda = 'La agenda con permisos requiere activar acceso al sistema';
        }

        if (Object.keys(errores).length > 0) {
            setErrorlist(errores);
            setBanner({
                type: 'warning',
                message: 'Revise los campos obligatorios (marcados con *) y los mensajes debajo de cada campo.'
            });
            requestAnimationFrame(() => scrollToFirstError(Object.keys(errores)));
            setLoading(false);
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            name: name.trim(),
            lastname: lastname.trim(),
            email: email.trim(),
            numero_documento: docDigits,
            tipo_documento: tipoDocumento,
            celular: celDigits,
            // Validación: convertir strings vacíos a null para campos integer
            cargo: cargo && cargo !== '' ? parseInt(cargo) : null,
            tipo_contrato: tipoContrato && tipoContrato !== '' ? parseInt(tipoContrato) : null,
            especialidad: especialidad && especialidad !== '' ? parseInt(especialidad) : null,
            // Campos de texto opcionales
            registro_medico: registroMedico || null,
            codigo_habilitacion: codigoHabilitacion || null,
            crear_cuenta: crearCuenta,
            activar_directo: crearCuenta ? true : false,
            direccion: direccion || null,
            ciudad: ciudadResidencia && ciudadResidencia !== '' ? parseInt(ciudadResidencia) : null,
            telefono: telefono || null,
            fecha_nacimiento: fechaNacimiento || null,
            estado_civil: estadoCivil || null,
            fecha_ingreso: fechaIngreso || null,
            porcentaje_contratado: porcentajeContratado && porcentajeContratado !== '' ? parseInt(porcentajeContratado) : null,
            crear_agenda: crearAgenda,
            diligenciar_historias: resolverDiligenciarHistorias(),
            facturador: facturador
        };

        if (crearCuenta) {
            conf.tipo_usuario = parseInt(tipoUsuario, 10);
            conf.password = String(password).trim();
            conf.roles = JSON.stringify(usrRoles);
        }

        axios.post('/user', conf)
            .then(() => {
                setBanner({
                    type: 'success',
                    message: 'El personal se creó correctamente. Redirigiendo al listado…'
                });
                setLoading(false);
                setTimeout(() => {
                    localStorage.setItem('toastmsg', 'El usuario "' + name.trim() + ' ' + lastname.trim() + '" ha sido creado');
                    history.push('/personal');
                }, 1400);
            })
            .catch((err) => {
                console.log('Error del servidor:', err.response?.data);
                const apiErrors = normalizeApiErrors(err);
                const generalMsg = apiErrors.general;
                const fieldErrors = { ...apiErrors };
                delete fieldErrors.general;
                setErrorlist(fieldErrors);
                const fieldKeys = Object.keys(fieldErrors);
                setBanner({
                    type: 'danger',
                    message:
                        generalMsg ||
                        (fieldKeys.length > 0
                            ? 'No se pudo crear el usuario. Revise los campos indicados.'
                            : 'Error al guardar. Intente de nuevo.')
                });
                if (fieldKeys.length > 0) {
                    requestAnimationFrame(() => scrollToFirstError(fieldKeys));
                }
                setLoading(false);
            });
    };








    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (

            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .nu-section-card { border-radius: 12px !important; overflow: hidden; }
                    .nu-section-header {
                        background: #f8f9fa;
                        border-bottom: 1px solid #eef0f2;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 14px 18px;
                        user-select: none;
                    }
                    .nu-section-header:hover { background: #f3f5f7; }
                    .nu-section-title { font-size: 1rem; font-weight: 700; color: #323a45; margin: 0; display: flex; align-items: center; gap: 10px; }
                    .nu-fieldset {
                        border: 1px solid #eef0f2;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem 0.65rem;
                        margin-bottom: 1.15rem;
                        background: #fcfcfd;
                    }
                    .nu-fieldset legend {
                        float: none;
                        width: auto;
                        padding: 0 6px;
                        margin-bottom: 0.85rem;
                        font-size: 0.72rem;
                        font-weight: 700;
                        text-transform: uppercase;
                        letter-spacing: 0.45px;
                        color: #7d7d7d;
                    }
                    .nu-subcard {
                        border: 1px solid #e8ecef;
                        border-radius: 12px;
                        padding: 1.15rem 1.25rem;
                        background: #fff;
                        margin-top: 1rem;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.05);
                    }
                    .nu-subcard legend {
                        float: none;
                        width: auto;
                        padding: 0 10px;
                        font-size: 0.92rem;
                        font-weight: 700;
                        color: #117a8b;
                        margin-bottom: 0.75rem;
                    }
                    .nu-alert-danger { border-radius: 10px; border: none; box-shadow: 0 2px 8px rgba(220,53,69,0.12); }
                    .nu-users-badge {
                        display: inline-block;
                        margin-top: 6px;
                        padding: 4px 12px;
                        border-radius: 999px;
                        font-size: 0.72rem;
                        font-weight: 700;
                        background: rgba(23,162,184,0.1);
                        color: #117f90;
                        border: 1px solid rgba(23,162,184,0.2);
                    }
                    .role-selector-card {
                        display: flex;
                        align-items: center;
                        padding: 12px 15px;
                        border: 1px solid #e8ecef;
                        border-radius: 10px;
                        margin-bottom: 15px;
                        background: #ffffff;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.04);
                    }
                    .role-selector-card:hover {
                        border-color: #17a2b8;
                        background: #f6fcfd;
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(23,162,184,0.1);
                    }
                    /* Interruptores compactos en todo el formulario (crear cuenta, agenda, historias, roles) */
                    #role-form .sm-switch-container {
                        width: 44px !important;
                        height: 24px !important;
                        border-radius: 24px !important;
                        flex-shrink: 0;
                    }
                    #role-form .sm-switch-container .sm-switch {
                        width: 18px !important;
                        height: 18px !important;
                        top: 3px !important;
                        left: 3px !important;
                    }
                    #role-form .sm-switch-container.on .sm-switch {
                        left: 23px !important;
                    }
                    #role-form .role-selector-card .sm-switch-container {
                        margin-right: 12px;
                    }
                    .role-selector-card label {
                        margin: 0 !important;
                        cursor: pointer !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        color: #323a45 !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .nu-fieldset-inner { border: 1px solid #eef0f2; border-radius: 12px; padding: 1rem; background: #fafbfc; margin-top: 0.5rem; }
                    .nu-crear-cuenta-row {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 12px 14px;
                        min-height: 38px;
                    }
                    .nu-crear-cuenta-row .nu-crear-cuenta-label {
                        margin: 0;
                        font-weight: 600;
                        color: #495057;
                        font-size: 13px;
                        line-height: 1.35;
                        flex: 1 1 140px;
                        min-width: 0;
                    }
                    .nu-crear-cuenta-row .sm-switch-container {
                        flex-shrink: 0;
                        align-self: center;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/personal">Personal y Profesionales</Link></li>
                                        <li className="breadcrumb-item active" key="bc5">Nuevo Personal</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Nuevo Personal</h1>
                                    <p className="text-muted mb-0 mt-1" style={{ fontSize: '0.85rem' }}>Registre datos del colaborador y, si aplica, cuenta de acceso al sistema.</p>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/personal" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al listado
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-12">

                                    <form id="role-form" onSubmit={handleSubmit}>

                                        {banner.message ? (
                                            <div
                                                className={`alert nu-alert-danger ${banner.type === 'success' ? 'alert-success' : banner.type === 'warning' ? 'alert-warning' : 'alert-danger'}`}
                                                role="alert"
                                            >
                                                {banner.type === 'danger' ? <i className="fas fa-exclamation-triangle mr-2"></i> : null}
                                                {banner.type === 'success' ? <i className="fas fa-check-circle mr-2"></i> : null}
                                                {banner.type === 'warning' ? <i className="fas fa-exclamation-circle mr-2"></i> : null}
                                                {banner.message}
                                            </div>
                                        ) : null}

                                        <p className="text-muted small mb-3">
                                            Los campos marcados con <span className="text-danger">*</span> son obligatorios. Si activa acceso al sistema, el email, tipo de usuario y contraseña también son obligatorios.
                                        </p>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonDatosBasicos(!acordeonDatosBasicos)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-id-card text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Datos básicos
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonDatosBasicos ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="infobasica" className={acordeonDatosBasicos ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información personal</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="name">Nombres</label>
                                                                    <input type="text" name="name" className="form-control" id="name" autoFocus onChange={(e) => setName(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="lastname">Apellidos <span className="text-danger">*</span></label>
                                                                    <input type="text" name="lastname" className={`form-control${errorlist.lastname ? ' is-invalid' : ''}`} id="lastname" value={lastname || ''} onChange={(e) => setLastname(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.lastname}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_documento">Tipo documento <span className="text-danger">*</span></label>
                                                                    <select name="tipo_documento" id="tipo_documento" className={`form-control${errorlist.tipo_documento ? ' is-invalid' : ''}`} value={tipoDocumento || ''} onChange={(e) => setTipoDocumento(e.target.value)}>
                                                                        <option value=""></option>
                                                                        <option value="cc">CC - CEDULA DE CIUDADANIA</option>
                                                                        <option value="ce">CE - CEDULA DE EXTRANJERIA</option>
                                                                        <option value="CD">CD - CARNET DIPLOMATICO</option>
                                                                        <option value="CN">CN - CERTIFICADO DE NACIDO VIVO</option>
                                                                        <option value="DE">DE - DOCUMENTOS EXTRANJERO</option>
                                                                        <option value="MS">MS - MENOR SIN IDENTIFICAR</option>
                                                                        <option value="NIP">NIP - NUMERO DE IDENTIFICACION PERSONAL</option>
                                                                        <option value="NIT">NIT - NUMERO DE IDENTIFICACION TRIBUTARIA</option>
                                                                        <option value="PA">PA - PASAPORTE</option>
                                                                        <option value="PT">PT - PERMISO TEMPORAL DE PERMANENCIA</option>
                                                                        <option value="PE">PE - PERMISO ESPECIAL DE PERMANENCIA</option>
                                                                        <option value="RC">RC - REGISTRO CIVIL</option>
                                                                        <option value="ti">TI - TARJETA DE IDENTIDAD</option>
                                                                        <option value="SC">SC - SALVOCONDUCTO DE PERMANENCIA</option>
                                                                        <option value="SI">SI - SIN IDENTIFICACION</option>
                                                                        <option value="AS">AS - ADULTO SIN IDENTIFICAR</option>
                                                                    </select>
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.tipo_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="documento">Documento <span className="text-danger">*</span></label>
                                                                    <input type="text" name="documento" className={`form-control${errorlist.numero_documento ? ' is-invalid' : ''}`} id="documento" value={documento || ''} onChange={(e) => setDocumento(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.numero_documento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información de contacto</legend>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="direccion">Dirección</label>
                                                                    <input type="text" name="direccion" className="form-control" id="direccion" onChange={(e) => setDireccion(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.direccion}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="ciudadResidencia">Ciudad de Residencia</label>
                                                                    <SelectorCiudad
                                                                        value={ciudadResidencia}
                                                                        onChange={setCiudadResidencia}
                                                                    />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.ciudad}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="telefono">Teléfono Fijo</label>
                                                                    <input type="text" name="telefono" className="form-control" id="telefono" onChange={(e) => setTelefono(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.telefono}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="celular">Teléfono celular <span className="text-danger">*</span></label>
                                                                    <input type="text" name="celular" className={`form-control${errorlist.celular ? ' is-invalid' : ''}`} id="celular" value={celular || ''} onChange={(e) => setCelular(e.target.value)} />
                                                                    <small className="form-text text-muted">Solo números, 10 a 15 dígitos.</small>
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.celular}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="email">Email <span className="text-danger">*</span></label>
                                                                    <input type="text" name="email" className={`form-control${errorlist.email ? ' is-invalid' : ''}`} id="email" value={email || ''} onChange={(e) => setEmail(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_nacimiento">Fecha de Nacimiento</label>
                                                                    <input type="date" name="fecha_nacimiento" className="form-control" id="fecha_nacimiento" onChange={(e) => setFechaNacimiento(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.fecha_nacimiento}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="estado_civil">Estado Civil</label>
                                                                    <select name="tipo-sangre" className="form-control" id="estadoCivil" onChange={(e) => setEstadoCivil(e.target.value)}>
                                                                        <option value=""></option>
                                                                        <option value="soltero">SOLTERO</option>
                                                                        <option value="casado">CASADO</option>
                                                                        <option value="separado">SEPARADO</option>
                                                                        <option value="viudo">VIUDO</option>
                                                                        <option value="union_libre">UNIÓN LIBRE</option>
                                                                        <option value="otro">OTRO</option>
                                                                    </select>
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.estado_civil}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label htmlFor="tipo_contrato">Tipo de contrato <span className="text-danger">*</span></label>
                                                                    <select name="tipo_contrato" id="tipo_contrato" className={`form-control${errorlist.tipo_contrato ? ' is-invalid' : ''}`} value={tipoContrato || ''} onChange={(e) => setTipoContrato(e.target.value)}>
                                                                        <option value="">-</option>
                                                                        {
                                                                            tiposContrato.map((tc) =>
                                                                                <option value={tc.id} key={'j' + tc.id}>{tc.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.tipo_contrato}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </fieldset>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonProfesionalSalud(!acordeonProfesionalSalud)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-user-md text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Profesional de la salud
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonProfesionalSalud ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="datosadicionales" className={acordeonProfesionalSalud ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    <fieldset className="nu-fieldset">
                                                        <legend>Información laboral</legend>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="fecha_ingreso">Fecha de Ingreso</label>
                                                                    <input type="date" name="fecha_ingreso" className="form-control" id="fecha_ingreso" onChange={(e) => setFechaIngreso(e.target.value)} />
                                                                    <div className="invalid-feedback visible">
                                                                        {errorlist?.fecha_ingreso}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="cargo">Cargo</label>
                                                                    <select name="cargo" id="cargo" className="form-control" onChange={(e) => setCargo(e.target.value)}>
                                                                        <option value="00">-</option>
                                                                        {
                                                                            cargos.map((cargoItem) =>
                                                                                <option value={cargoItem.id} key={'k' + cargoItem.id}>{cargoItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="registro_medico">Registro Médico</label>
                                                                    <input type="text" name="registro_medico" className="form-control" id="registro_medico" onChange={(e) => setRegistroMedico(e.target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="especialidad">Especialidad</label>
                                                                    <select name="especialidad" id="especialidad" className="form-control" onChange={(e) => setEspecialidad(e.target.value)}>
                                                                        <option value="00">-</option>
                                                                        {
                                                                            especialidades.map((especialidadItem) =>
                                                                                <option value={especialidadItem.id} key={'p' + especialidadItem.id}>{especialidadItem.nombre}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="codigo_habilitacion">Código de Habilitación</label>
                                                                    <input type="text" name="codigo_habilitacion" className="form-control" id="codigo_habilitacion" onChange={(e) => setCodigoHabilitacion(e.target.value)} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label htmlFor="porcentaje_contratado">Porcentaje contratado</label>
                                                                    <input type="number" min="0" max="100" name="porcentaje_contratado" className={`form-control${errorlist.porcentaje_contratado ? ' is-invalid' : ''}`} id="porcentaje_contratado" value={porcentajeContratado || ''} onChange={(e) => setPorcentajeContratado(e.target.value)} />
                                                                    <div className="invalid-feedback d-block">
                                                                        {errorlist.porcentaje_contratado}
                                                                    </div>
                                                                </div>
                                                            </div>



                                                        </div>

                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card shadow-sm border-0 mb-4 nu-section-card">
                                            <div className="card-header nu-section-header border-0 rounded-0" onClick={() => setAcordeonUsuarioSistema(!acordeonUsuarioSistema)}>
                                                <h2 className="nu-section-title">
                                                    <i className="fas fa-key text-info" style={{ opacity: 0.9 }} aria-hidden="true"></i>
                                                    Usuario del sistema
                                                </h2>
                                                <i className={`fas fa-chevron-${acordeonUsuarioSistema ? 'up' : 'down'} text-muted`} aria-hidden="true"></i>
                                            </div>
                                            <div id="rolesusuario" className={acordeonUsuarioSistema ? '' : 'collapse'}>
                                                <div className="card-body pt-3">

                                                    {/* Alineado con col-md-3 de «Fecha de ingreso» del acordeón anterior */}
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <div className="form-group mb-2">
                                                                <div className="nu-crear-cuenta-row">
                                                                    <label className="nu-crear-cuenta-label" htmlFor="crear_cuenta">
                                                                        ¿Crear cuenta de usuario en la plataforma?
                                                                    </label>
                                                                    <div className="sm-switch-container" id="crear_cuenta" onClick={handleCrearCuenta}>
                                                                        <span className="sm-switch"></span>
                                                                    </div>
                                                                </div>
                                                                <span className="nu-users-badge mt-2 d-inline-block" title="Cupos por tipo de usuario activo">
                                                                    {CUPOS_SALUD}: {cuposMedicos.creados}/{cuposMedicos.disponibles} (libres {cuposLibresMedicos})
                                                                    {' · '}
                                                                    {CUPOS_ADMIN}: {cuposAdmin.creados}/{cuposAdmin.disponibles} (libres {cuposLibresAdmin})
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-md-12">
                                                            <label className="d-block font-weight-bold text-secondary small text-uppercase mb-2">¿Crear agenda para este profesional?</label>
                                                            <div
                                                                className={`sm-switch-container${crearAgenda ? ' on' : ''}${!crearCuenta ? ' opacity-50' : ''}`}
                                                                id="agenda-crear"
                                                                onClick={handleCrearAgenda}
                                                                title={!crearCuenta ? 'Requiere activar acceso al sistema' : ''}
                                                            >
                                                                <span className="sm-switch"></span>
                                                            </div>
                                                            <small className="form-text text-muted d-block mt-2">
                                                                {crearCuenta
                                                                    ? 'Se creará la agenda, se asignará como favorita y se darán permisos a este usuario y a quien la crea.'
                                                                    : 'Disponible solo si activa «Crear cuenta de usuario en la plataforma».'}
                                                            </small>
                                                            {errorlist.crear_agenda && (
                                                                <div className="text-danger small mt-1">{errorlist.crear_agenda}</div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* 🔒 CAMPOS CONDICIONALES - SOLO VISIBLES SI SE ACTIVA EL SWITCH */}
                                                    {camposUsuarioVisible && (
                                                        <>
                                                            {/* 🔐 INFORMACIÓN DE INICIO DE SESIÓN */}
                                                            <fieldset className="nu-subcard">
                                                                <legend>Datos de inicio de sesión</legend>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor="tipo_usuario">
                                                                                Tipo de usuario <span className="text-danger">*</span>
                                                                            </label>
                                                                            <select
                                                                                name="tipo_usuario"
                                                                                id="tipo_usuario"
                                                                                className={`form-control${errorlist.tipo_usuario ? ' is-invalid' : ''}`}
                                                                                value={tipoUsuario}
                                                                                onChange={(e) => setTipoUsuario(e.target.value)}
                                                                                style={{ borderRadius: '10px' }}
                                                                            >
                                                                                <option value="0">{TIPO_USUARIO_LABEL['0']} ({cuposLibresMedicos} cupos libres)</option>
                                                                                <option value="1">{TIPO_USUARIO_LABEL['1']} ({cuposLibresAdmin} cupos libres)</option>
                                                                            </select>
                                                                            <small className="form-text text-muted">
                                                                                El acceso consume un cupo del tipo seleccionado. Ingreso con email y contraseña.
                                                                            </small>
                                                                            <div className="invalid-feedback d-block">
                                                                                {errorlist.tipo_usuario}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor="password">
                                                                                Contraseña <span className="text-danger">*</span>
                                                                            </label>
                                                                            <input
                                                                                type="password"
                                                                                name="password"
                                                                                className={`form-control${errorlist.password ? ' is-invalid' : ''}`}
                                                                                id="password"
                                                                                autoComplete="new-password"
                                                                                value={password}
                                                                                onChange={(e) => setPassword(e.target.value)}
                                                                                placeholder="Mínimo 6 caracteres"
                                                                                required={crearCuenta}
                                                                            />
                                                                            <small className="form-text text-muted">
                                                                                Obligatoria para activar el acceso. El usuario ingresa con su email.
                                                                            </small>
                                                                            <div className="invalid-feedback d-block">
                                                                                {errorlist.password}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {/* 💰 PERMISOS DE FACTURACIÓN */}
                                                            <fieldset className="nu-subcard">
                                                                <legend>Permisos de facturación</legend>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <label htmlFor="facturador" className="font-weight-bold text-secondary">¿Es facturador?</label>
                                                                        <select 
                                                                            className="form-control mt-1" 
                                                                            value={facturador} 
                                                                            onChange={(e) => setFacturador(parseInt(e.target.value))}
                                                                            style={{ maxWidth: '520px', borderRadius: '10px' }}
                                                                        >
                                                                            <option value={0}>Sí - Puede crear RIPS FEV y Convenios</option>
                                                                            <option value={1}>No - Solo RIPS Sin FEV</option>
                                                                        </select>
                                                                        <small className="form-text text-muted">
                                                                            Define qué opciones de RIPS puede usar el usuario al atender pacientes
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </fieldset>

                                                            {/* 👥 ASIGNACIÓN DE ROLES */}
                                                            <div className={'row ' + asignarRolesVisible} style={{ marginTop: '12px' }}>
                                                                <div className="col-md-12">
                                                                    <fieldset className="nu-fieldset-inner">
                                                                        <legend className="mb-3" style={{ fontSize: '0.92rem', fontWeight: 700, color: '#117a8b', border: 'none', padding: 0 }}>Asignar perfil de usuario</legend>
                                                                        <div className="row">
                                                                            {roles.map((role) =>
                                                                                <div className="col-md-4" key={'role-' + role.id}>
                                                                                    <div className="role-selector-card" onClick={() => addRole(role.id)}>
                                                                                        <div className="sm-switch-container" id={'role-' + role.id}>
                                                                                            <span className="sm-switch"></span>
                                                                                        </div>
                                                                                        <label title={role.name}>{role.name}</label>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </fieldset>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row align-items-center mb-4" style={{ marginTop: '8px' }}>
                                            <div className="col-md-auto pr-md-2">
                                                <button type="submit" className="btn btn-info font-weight-bold px-4" disabled={loading} style={{ borderRadius: '10px', minWidth: '200px' }}>
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                            Guardando…
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fas fa-save mr-2"></i>
                                                            Guardar personal
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                            <div className="col-md-auto pt-2 pt-md-0">
                                                <Link to="/personal" className="btn btn-outline-secondary" style={{ borderRadius: '10px' }}>
                                                    Cancelar
                                                </Link>
                                            </div>
                                        </div>




                                    </form>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>

        );
    }

    return (
        <Loading />
    );
}
export default NuevoUsuario;